export function IndeterminateCheckIcon() {
  return (
    <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
      <rect width="12" height="2" rx="1" fill={"currentColor"} />
    </svg>
  );
}
